/*
 * @Description:
 * @Date: 2024-03-20 10:58:31
 */
import { Ref, computed, ref } from 'vue';
import { BaseCascaderProps } from 'xrk-components';
import { TagType } from '../data-source/types';
import { getConfigCityList } from '../data-source/api';

export const useProvince = (addressChooseTag?: Ref<TagType>) => {
  const ALL_STR = '全国';
  const ALL_KEY = -1;
  const _addressData = ref<BaseCascaderProps['options']>();
  const _addressDataMap = new Map<
    number,
    BaseCascaderProps['options'] extends Array<any>
      ? BaseCascaderProps['options'][number]
      : any
  >();
  const addressDataChange = () => {
    if (!addressChooseTag || !addressChooseTag.value) return;
    addressChooseTag.value._provinceChooseAllMap = new Map();
    const chooseTagValues = addressChooseTag.value.chooseTagValues as Array<
      Array<number>
    >;
    if (
      chooseTagValues.length > 1 &&
      chooseTagValues[chooseTagValues.length - 1].some(i => i == ALL_KEY)
    ) {
      addressChooseTag.value.chooseTagValues = [[ALL_KEY]];
      addressChooseTag.value.chooseTagValuesStr = [
        { index: 0, value: ALL_STR }
      ];
      return;
    }
    addressChooseTag.value.chooseTagValuesStr = (() => {
      if (addressChooseTag.value === undefined) return [];
      const provinceMap = (
        addressChooseTag.value.chooseTagValues as Array<any>
      ).reduce((pre, [provinceId, cityId]) => {
        pre[provinceId] = [...(pre[provinceId] || []), cityId];
        return pre;
      }, {});
      const _provinceAllChooseMap = Object.entries(provinceMap).reduce(
        (pre, [provinceId, chooseAllCityId]) => {
          const allCityIdStr = Array.from(
            (_addressDataMap.get(+provinceId)?.children || new Map()).keys()
          )
            .sort()
            .join('_');
          const chooseAllCityIdStr = Array.isArray(chooseAllCityId)
            ? chooseAllCityId.sort().join('_')
            : '';
          pre.set(+provinceId, allCityIdStr == chooseAllCityIdStr);
          return pre;
        },
        addressChooseTag.value._provinceChooseAllMap
      );

      const allMap = new Map<
        string,
        { value: string; provinceId: any; cityId: any }
      >();
      addressChooseTag.value.chooseTagValues.forEach((item: Array<any>) => {
        const [f1, f2] = item;
        const provinceId = _addressDataMap.get(f1)?.value;
        const cityId = _addressDataMap.get(f1)?.children?.get(f2)?.value;
        // 区县全选的话，只显示省份
        const value = _provinceAllChooseMap.get(f1)
          ? _addressDataMap.get(f1)?.label
          : [
              _addressDataMap.get(f1)?.label,
              _addressDataMap.get(f1)?.children?.get(f2)?.label
            ]
              .filter(Boolean)
              .map(i => i)
              .join('/');
        if (!allMap.has(value)) {
          allMap.set(value, {
            provinceId,
            cityId: _provinceAllChooseMap.get(f1) ? null : cityId,
            value
          });
        }
      });
      return Array.from(allMap.values()).map((item, index) => ({
        ...item,
        index
      }));
    })();
  };
  const initAddressData = async () => {
    const { data } = await getConfigCityList();
    const remoteData = [
      { label: ALL_STR, value: ALL_KEY, children: [] },
      ...data.map(city => ({
        label: city.areaName,
        value: city.id,
        children:
          city.children?.map(area => ({
            label: area.areaName,
            value: area.id
          })) || []
      }))
    ];
    remoteData.forEach(item => {
      _addressDataMap.set(item.value, {
        ...item,
        children: Array.isArray(item.children)
          ? item.children.reduce((pre, cur) => {
              pre.set(cur.value, cur);
              return pre;
            }, new Map())
          : new Map()
      });
    });
    _addressData.value = remoteData as BaseCascaderProps['options'];
    addressDataChange();
  };
  initAddressData();

  return {
    addressDataChange,
    addressData: computed(() =>
      Array.isArray(_addressData.value)
        ? _addressData.value.map(item => ({
            ...item,
            disabled: !addressChooseTag
              ? true
              : addressChooseTag.value.chooseTagValues.findIndex(
                  (i: Array<number>) => i.some(t => t == -1)
                ) > -1 && item.value != -1
              ? true
              : false
          }))
        : []
    )
  };
};
